import _ from 'lodash';
import { initDycolor, adapi, storeGetters, permissions, Debug } from '~';
import { STEP_STATUS } from '@/util/constants';
import { mapActions, mapGetters, mapState } from 'vuex';

initDycolor('workflow-progress', require(`${process.env.DYCOLOR_REQUIRE}./WorkflowProgress.scss`)); // eslint-disable-line

const debug = Debug('workflow-progress');

export default {
  props: {
    title: {
      type: String,
      default: null,
    },
    notification: {
      type: Object,
      default: null,
    },
    steps: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      stepStatus: STEP_STATUS,
    };
  },
  computed: {
    ...mapGetters('campaign', { campaign: 'currentCampaign' }),
    ...mapState('genericConfig', ['config']),
    showDates() {
      return _.get(this.config, 'feature_show_progress_dates', false);
    },
    permissions() {
      return permissions.getPermissions(this.campaign);
    },
    canMoveCampaign() {
      return this.permissions.includes('moveToCap');
    },
    isCampaignWorkflowView() {
      return this.$router.currentRoute.name === 'campaign';
    },
    getCampaignProductionProgress() {
      const creativeStatus = _.get(this.campaign, 'creatives', [])
        .filter(arr => arr.active === 1)[0];
      switch (_.get(creativeStatus, 'status', null)) {
        case 'BRIEF':
          return 25;
        case 'WIP':
          return 50;
        case 'HOLD': // HOLD + READY
        case 'READY':
          return 75;
        case 'APPROVED':
          return 100;
        default:
          return 10;
      }
    },
  },
  methods: {
    ...mapActions('campaign', ['reloadCampaign']),
    forceMoveCampaign() {
      adapi.post(`campaigns/${storeGetters.getRouterParams().code}/move`, { status: 'CAP' }, null)
        .then(result => {
          debug.info('success', result);
          this.$toast.success({ message: this.$t('pos.campaign.moved') });
        })
        .then(() => this.reloadCampaign())
        .catch(error => {
          this.$toast.error({ message: adapi.translateAdapiErrors(error.errors, this.$t) });
        });
    },
  },
};



// WEBPACK FOOTER //
// ./src/components/rabbit/workflow-progress/WorkflowProgress.js